export default "/static/webpack/media/ebhr-logo-white.50c24f09.svg";